// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const HeartFilledIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'heart-filled'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M23.5 8.5C23.5 11.471 21.5375 13.6155 20.0508 15.0723L20.0488 15.0703L13.0605 22.0605C12.4748 22.6463 11.5252 22.6463 10.9395 22.0605L3.95703 15.0781C2.44857 13.6199 0.5 11.4794 0.5 8.5C0.5 6.64348 1.23803 4.86354 2.55078 3.55078C3.86354 2.23803 5.64348 1.5 7.5 1.5C8.53028 1.5 9.49557 1.648 10.4473 2.0625C10.9942 2.30078 11.5037 2.61601 12 3C12.4963 2.61601 13.0058 2.30078 13.5527 2.0625C14.5044 1.648 15.4697 1.5 16.5 1.5C18.3565 1.5 20.1365 2.23803 21.4492 3.55078C22.762 4.86354 23.5 6.64349 23.5 8.5Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
HeartFilledIcon.displayName = 'HeartFilledIcon'
export { HeartFilledIcon }
